import Vue            from "vue";
import Vuex           from "vuex";
import User           from "@/utils/User";
import { LANG }       from "@/i18n/main";
import { translator } from "@/i18n/translator";

Vue.use(Vuex);

class Storage {
    static save(key, val) {
        sessionStorage.setItem(sessionStorage.docsetID + "." + key, val);
    }

    static get(key, defVal) {
        const item = sessionStorage.getItem(sessionStorage.docsetID + "." + key);
        return defVal !== undefined ? (item || defVal) : item;
    }
}

function detect_locale() {
    if (sessionStorage.locale) {
        return sessionStorage.locale;
    }
    const lang = LANG[navigator.language.toUpperCase()];
    return lang ? lang.CODE : LANG.RU.CODE;
}

export const store = new Vuex.Store({
    state: {
        locale: detect_locale(),
        add_message: Storage.get("add_message", ""),
        message: Storage.get("message", ""),
        res_text: "",
        res_text_style: "",
        res_button_state: "enabled",
        sms_confirm: {
            code: null,
            text: "",
        },
        repay: {
            dateofbirth: null,
            account: "",
            fullname: "",
            loans: []
        },
        user: new User(
            sessionStorage.token,
            sessionStorage.pinCode,
            sessionStorage.docsetID
        ),
        showDocuments: Storage.get("showDocuments", false),
    },
    getters: {
        locale(state) {
            return state.locale;
        },
        // eslint-disable-next-line no-unused-vars
        host(state) {
            return process.env.NODE_ENV === "development" ? process.env.VUE_APP_EDOC_HOST : "/api";
        },
        add_message(state) {
            return state.add_message;
        },
        message(state) {
            return state.message;
        },
        res_text(state) {
            return state.res_text;
        },
        res_text_style(state) {
            return state.res_text_style;
        },
        res_button_state(state) {
            return state.res_button_state;
        },
        sms_confirm(state) {
            return state.sms_confirm;
        },
        user(state) {
            return state.user;
        },
        showDocuments(state) {
            return state.showDocuments;
        },
        repay(state) {
            return state.repay;
        },
    },
    mutations: {
        set_locale(state, payload) {
            state.locale = payload;
            translator.lang = payload;
            sessionStorage.setItem("locale", payload);
        },
        set_add_message(state, payload) {
            state.add_message = payload;
            Storage.save("add_message", payload);
        },
        set_message(state, payload) {
            state.message = payload;
            Storage.save("message", payload);
        },
        set_res_text(state, payload) {
            state.res_text = payload;
        },
        set_res_text_style(state, payload) {
            state.res_text_style = payload;
        },
        set_res_button_state(state, payload) {
            state.res_button_state = payload;
        },
        set_sms_confirm(state, payload) {
            state.sms_confirm = payload;
        },
        set_user(state, user) {
            state.user = user;
            sessionStorage.setItem("token", user.token);
            sessionStorage.setItem("pinCode", user.pinCode);
            sessionStorage.setItem("docsetID", user.docsetID);
        },
        setShowDocuments(state, payload) {
            state.showDocuments = payload;
            Storage.save("showDocuments", payload);
        },
        setRepay(state, repay) {
            state.repay = repay;
        }
    },
    actions: {
        set_locale(ctx, payload) {
            ctx.commit("set_locale", payload);
        },
        set_add_message(ctx, payload) {
            ctx.commit("set_add_message", payload);
        },
        set_message(ctx, payload) {
            ctx.commit("set_message", payload);
        },
        set_res_text(ctx, payload) {
            ctx.commit("set_res_text", payload);
        },
        set_res_text_style(ctx, payload) {
            ctx.commit("set_res_text_style", payload);
        },
        set_res_button_state(ctx, payload) {
            ctx.commit("set_res_button_state", payload);
        },
        set_sms_confirm(ctx, payload) {
            ctx.commit("set_sms_confirm", payload);
        },
        setShowDocuments(ctx, payload) {
            ctx.commit("setShowDocuments", payload);
        }
    }
});